import { FormProvider } from 'react-hook-form';
import { Outlet } from 'react-router-dom';
import styles from './FormBuilderLayout.module.css';
import { useFormBuilderSubmit } from './hooks/useFormBuilderSubmit';
import { useFormBuilderTemplate } from './hooks/useFormBuilderTemplate';
import { Loader } from '@/components/Loader';

export const FormBuilderLayout = () => {
  const { loading, methods } = useFormBuilderTemplate();
  const { onSubmit, onError } = useFormBuilderSubmit();

  if (loading) return <Loader full />;

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit, onError)}
        className={styles.container}
        aria-label="form"
      >
        <Outlet />
      </form>
    </FormProvider>
  );
};
